import { render } from "./AIDictation.vue?vue&type=template&id=9d6f5472&scoped=true&ts=true"
import script from "./AIDictation.vue?vue&type=script&lang=ts"
export * from "./AIDictation.vue?vue&type=script&lang=ts"

import "./AIDictation.vue?vue&type=style&index=0&id=9d6f5472&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d6f5472"]])

export default __exports__